"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Steps.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Steps = function Steps(_ref) {
  var className = _ref.className,
      steps = _ref.steps,
      stepActive = _ref.stepActive;
  return _react.default.createElement("ol", {
    className: className ? "steps ".concat(className) : 'steps'
  }, steps.map(function (step, index) {
    return _react.default.createElement("li", {
      className: stepActive === index + 1 ? 'steps__item steps__item--active' : 'steps__item',
      key: index
    }, _react.default.createElement("span", {
      className: "steps__text"
    }, step));
  }));
};

Steps.defaultProps = {
  className: '',
  steps: [],
  stepActive: 1
};
Steps.propTypes = {
  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Array contendo os passos */
  steps: _propTypes.default.array.isRequired,

  /** Passo ativo */
  stepActive: _propTypes.default.number
};
var _default = Steps;
exports.default = _default;